import styled from "@emotion/styled";

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--mobile-columns), minmax(0, 1fr));
  column-gap: var(--mobile-column-gap, 0);
  row-gap: var(--mobile-row-gap, 0);

  .header-element-wrapper,
  .footer-element-wrapper {
    grid-column: 1 / -1;
  }

  .header-element-wrapper {
    display: var(--header-mobile-display, block);
  }

  .footer-element-wrapper {
    display: var(--footer-mobile-display, block);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(var(--tablet-columns), minmax(0, 1fr));
    column-gap: var(--tablet-column-gap, 0);
    row-gap: var(--tablet-row-gap, 0);

    .header-element-wrapper {
      display: var(--header-tablet-display, block);
    }

    .footer-element-wrapper {
      display: var(--footer-tablet-display, block);
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(var(--desktop-columns), minmax(0, 1fr));
    column-gap: var(--desktop-column-gap, 0);
    row-gap: var(--desktop-row-gap, 0);

    .header-element-wrapper {
      display: var(--header-desktop-display, block);
    }

    .footer-element-wrapper {
      display: var(--footer-desktop-display, block);
    }
  }
`;
